import BaseActions from '../../app/_base_actions';
import Rest from '../../webapi/Rest';


const EnumHomeActions = Object.freeze({
    STATISTICHE: 'HOME_STATISTICHE',
});

module.exports.HomeActions = EnumHomeActions;


class HomeActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[HomeActions] ";
    }
    
    get Actions() {
        return EnumHomeActions;
    }

    getStatistiche() {
        return function (dispatch) {
            return Rest.post('admin/armCoreQuest/statistiche', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumHomeActions.STATISTICHE, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

};

export default HomeActions = new HomeActions;
